import { supervisionMessageAlert } from '@/util/notice';
import AudioPlayer from '@/util/audio';

const audioPlayer = AudioPlayer.init({
  src: require('@/assets/audio/remind-sound.wav'),
  loopCount: 1
});

let timerId = null;
let msgBox = null;

const state = {
  hasUnRead: false,
  readMessageList: []
};

const mutations = {
  setHasUnRead(state, status) {
    state.hasUnRead = status;
  },
  setReadMessageList(state, id) {
    state.readMessageList = state.readMessageList.concat(id);
  }
};

const actions = {
  async haveMessage({ commit, dispatch, rootGetters }) {
    try {
      if (rootGetters.isSupervision) {
        const { hasUnRead, messageResponse } = await Fetch.haveSupervisionMessage();

        commit('setHasUnRead', hasUnRead);

        if (messageResponse) {
          const { id } = messageResponse;
          if (!state.readMessageList.includes(id) && !msgBox) {
            audioPlayer.play();
            commit('setReadMessageList', id);
            msgBox = supervisionMessageAlert(messageResponse, () => {
              msgBox = null;
            });
          }
        }
        timerId = setTimeout(() => dispatch('haveMessage'), 10 * 1000);
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        if (msgBox) msgBox.close();
        clearTimeout(timerId);
      } else {
        throw error;
      }
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
